(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calculator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const input = document.getElementById('mould-water');
    const btn = document.getElementById('calculate-btn');
    const results = document.getElementById('calculator-results');
    const ratioNote = document.getElementById('ratio-note');
    const totalEl = document.getElementById('result-total');
    const powderEl = document.getElementById('result-powder');
    const waterEl = document.getElementById('result-water');

    function calculate() {
      const val = parseFloat(input.value);
      if (isNaN(val) || val <= 0) {
        results.classList.remove('is-visible');
        ratioNote.classList.remove('is-visible');
        return;
      }

      // Total composite = mould water quantity × 2 (accounts for density)
      const total = val * 2;
      // 3:1 ratio → powder = 75%, water = 25%
      const powder = total * 0.75;
      const water = total * 0.25;

      totalEl.textContent = total % 1 === 0 ? total : total.toFixed(1);
      powderEl.textContent = powder % 1 === 0 ? powder : powder.toFixed(1);
      waterEl.textContent = water % 1 === 0 ? water : water.toFixed(1);

      results.classList.add('is-visible');
      ratioNote.classList.add('is-visible');
    }

    btn.addEventListener('click', calculate);
    input.addEventListener('input', calculate);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        calculate();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
